import { Sort } from './components/types';

export function sortByProperty<T extends object>(
  arr: Array<T>,
  property: keyof T,
  direction: Sort,
): Array<T> {
  return arr.sort((a, b) => {
    if (direction === Sort.Asc) {
      if (a[property] < b[property]) {
        return -1;
      }
      if (a[property] > b[property]) {
        return 1;
      }
      return 0;
    } else {
      if (a[property] > b[property]) {
        return -1;
      }
      if (a[property] < b[property]) {
        return 1;
      }
      return 0;
    }
  });
}
